import {ContentCategory} from "../../../constant/CodeSpecNum";
import {updateIncidentForInProgress} from "../../../api/maintenance/IncidentService";
import {updateWorkForInProgress} from "../../../api/maintenance/WorkService";
import {updateInspectionForInProgress} from "../../../api/maintenance/InspectionService";
import {
    updateInProgressDone,
    updateServiceRequestForInProgress,
} from "../../../api/serviceRequest/ServiceRequestService";

/** 업무별 진행 작업·이력 저장 API 및 메타 설정 */
export const EXECUTION_RECORD_CONFIG = {
    [ContentCategory.INCIDENT]: {
        reworkType: "INCIDENT",
        fileCategory: ContentCategory.INCIDENT_IN_PROGRESS,
        updateForExecution: updateIncidentForInProgress,
        progressPanelTitle: "장애 요청 진행상태",
        verificationVariant: "incident",
    },
    [ContentCategory.WORK]: {
        reworkType: "WORK",
        fileCategory: ContentCategory.WORK_IN_PROGRESS,
        updateForExecution: updateWorkForInProgress,
        progressPanelTitle: "작업 요청 진행상태",
        verificationVariant: "work",
    },
    [ContentCategory.INSPECTION]: {
        reworkType: "INSPECTION",
        fileCategory: ContentCategory.INSPECTION_IN_PROGRESS,
        updateForExecution: updateInspectionForInProgress,
        progressPanelTitle: "점검 요청 진행상태",
        verificationVariant: "inspection",
    },
    [ContentCategory.SERVICE_REQUEST]: {
        reworkType: "SERVICE_REQUEST",
        fileCategory: ContentCategory.SERVICE_REQUEST_IN_PROGRESS,
        updateForExecution: updateServiceRequestForInProgress,
        completeForExecution: updateInProgressDone,
        completeModification: true,
        showCloseUser: true,
        progressPanelTitle: "서비스 요청 진행상태",
        verificationVariant: "serviceRequest",
    },
};
